<template>
  <div class="widget">
    <div class="widget-label">
      <div class="label">
        <p>New Metrics</p>
      </div>
      <!-- <b-button @click="addNew" variant="primary" class="right-align">{{ this.addNewText }}</b-button> -->
    </div>
    <b-tabs fluid>
      <b-tab 
        v-for="tab in tabs"
        :key="tab.name"
        class="project-metrics"
      >
        <template v-slot:title>
          <b-icon 
            :icon="tab.icon"
          ></b-icon>
          {{ tab.title }}
          <span 
            v-if="tab.itemsCount > 0" 
            class="notice"
          >
            {{ tab.itemsCount }}
          </span>
        </template>
        <b-row>
          <div class="widget-content">
            <!-- <ProjectMetricActionItems
              :actionItems="tab.items"
              :possibleAssignees="possibleAssignees"
              @refresh="refreshSpecificProjectMetric"
            /> -->

            <ProjectMetricActionItems
              v-if="tab.name === 'risks' || tab.name === 'issues'"
              :actionItems="tab.items"
            />


            <!-- <ProjectMetricEntries
              v-else
              :projectMetrics="tab.items"
              :fields="innovationsFields"
              @refresh="refreshSpecificProjectMetric"
            /> -->

            <ProjectMetricEntries
              v-else
              :projectMetrics="tab.items"
              :fields="metricColumns"
            />
          </div>
        </b-row>
      </b-tab>
    </b-tabs>
    <!-- <b-tabs fluid>
      <b-tab @click="setCurrentTab(0)" class="project-metrics">
        <template v-slot:title>
          <b-icon icon="list-check"></b-icon>Action Items
          <span v-if="actionItems.length > 0" class="notice">{{ actionItems.length }}</span>
        </template>
        <b-row>
          <div class="widget-content">
            <ProjectMetricActionItems
              :actionItems="actionItems"
              :possibleAssignees="possibleAssignees"
              @refresh="refreshSpecificProjectMetric"
            />
          </div>
        </b-row>
      </b-tab>
      <b-tab @click="setCurrentTab(1)" class="project-metrics">
        <template v-slot:title>
          <b-icon icon="lamp-fill"></b-icon>Innovations
          <span v-if="innovations.length > 0" class="notice">{{ innovations.length }}</span>
        </template>
        <b-row>
          <div class="widget-content">
            <ProjectMetricEntries
              :projectMetrics="visibleInnovations"
              :fields="innovationsFields"
              @refresh="refreshSpecificProjectMetric"
            ></ProjectMetricEntries>
            <div class="btn-wrapper">
              <b-button
                v-if="innovations.length > innovationsLength"
                @click="showMore('Innovations')"
                variant="tertiary"
                class="view"
              >Show More</b-button>
            </div>
          </div>
        </b-row>
      </b-tab>
      <b-tab @click="setCurrentTab(2)" class="project-metrics">
        <template v-slot:title>
          <b-icon icon="hourglass-split"></b-icon>Efficiencies
          <span v-if="efficiencies.length > 0" class="notice">{{ efficiencies.length }}</span>
        </template>
        <b-row>
          <div class="widget-content">
            <ProjectMetricEntries
              :projectMetrics="visibleEfficiencies"
              :fields="efficienciesFields"
              @refresh="refreshSpecificProjectMetric"
            ></ProjectMetricEntries>
            <div class="btn-wrapper">
              <b-button
                v-if="efficiencies.length > efficienciesLength"
                @click="showMore('Efficiencies')"
                variant="tertiary"
                class="view"
              >Show More</b-button>
            </div>
          </div>
        </b-row>
      </b-tab>
      <b-tab @click="setCurrentTab(3)" class="project-metrics">
        <template v-slot:title>
          <b-icon icon="lightning-fill"></b-icon>Sustainability
          <span
            v-if="sustainabilities.length > 0"
            class="notice"
          >{{ sustainabilities.length }}</span>
        </template>
        <b-row>
          <div class="widget-content">
            <ProjectMetricEntries
              :projectMetrics="visibleSustainabilities"
              :fields="sustainabilitiesFields"
              @refresh="refreshSpecificProjectMetric"
            ></ProjectMetricEntries>
            <div class="btn-wrapper">
              <b-button
                v-if="sustainabilities.length > sustainabilityLength"
                @click="showMore('Sustainability')"
                variant="tertiary"
                class="view"
              >Show More</b-button>
            </div>
          </div>
        </b-row>
      </b-tab>
      <b-tab @click="setCurrentTab(5)" class="project-metrics">
        <template v-slot:title>
          <b-icon icon="people-fill"></b-icon>Partnership
          <span v-if="partnerships.length > 0" class="notice">{{ partnerships.length }}</span>
        </template>
        <b-row>
          <div class="widget-content">
            <ProjectMetricEntries
              :projectMetrics="visiblePartnerships"
              :fields="partnershipFields"
              @refresh="refreshSpecificProjectMetric"
            ></ProjectMetricEntries>
            <div class="btn-wrapper">
              <b-button
                v-if="partnerships.length > length"
                @click="showMore('Partnership')"
                variant="tertiary"
                class="view"
              >Show More</b-button>
            </div>
          </div>
        </b-row>
      </b-tab>
      <b-tab @click="setCurrentTab(6)" class="project-metrics">
        <template v-slot:title>
          <b-icon icon="newspaper"></b-icon>News
          <span v-if="news.length > 0" class="notice">{{ news.length }}</span>
        </template>
        <b-row>
          <div class="widget-content">
            <NewsLinkEntries :newsLinks="news" />
          </div>
        </b-row>
        <div class="btn-wrapper">
        </div>
      </b-tab>
      <b-tab @click="setCurrentTab(4)" class="documents project-metrics">
        <template v-slot:title>
          <b-icon icon="file-earmark-fill"></b-icon>Documents
          <span v-if="documents.length > 0" class="notice">{{ documents.length }}</span>
        </template>
        <b-row>
          <div class="widget-content">
            <DocumentEntries :documents="visibleDocuments" />
            <div class="btn-wrapper">
              <b-button
                variant="tertiary"
                v-if="documents.length > documentsLength"
                @click="showMore('Documents')"
                class="view"
              >Show More</b-button>
            </div>
          </div>
        </b-row>
      </b-tab>
      <b-tab @click="setCurrentTab(7)" class="documents project-metrics">
        <template v-slot:title>
          <b-icon icon="calendar"></b-icon>Meetings
          <span v-if="openMeetings.length" class="notice">{{ openMeetings.length }}</span>
        </template>
        <b-row>
          <div class="widget-content">
            <b-table
              class="custom-table"
              :items="filteredMeetings"
              :fields="meetingFields"
              responsive
            >
              <template v-slot:cell(name)="data">
                <b-link
                  :to="getMeetingUrl(data.item)"
                >{{ meetingName(data.item.name) }}</b-link>
              </template>
              <template #cell(type)="data">
                <div>
                  <span v-if="!data.item.type">--</span>
                  <span v-else>{{ data.item.type }}</span>
                </div>
              </template>
              <template #cell(status)="data">
                <div class="lvl">
                  <span>{{ data.item.status }}</span>
                </div>
              </template>
              <template #cell(date)="data">
                <div>
                  <span>{{ $formatter.displayDate(data.item.date) }}</span>
                </div>
              </template>
              <template #cell(start)="data">
                <div>
                  <span>{{ $formatter.displayDate(data.item.start) }}</span>
                </div>
              </template>
              <template #cell(end)="data">
                <div>
                  <span>{{ $formatter.displayDate(data.item.end) }}</span>
                </div>
              </template>
              <template #cell(kebab)="data">
                <b-dropdown
                  id="dropdown-1"
                  class="kebab"
                  text="Additional Options"
                  variant="tertiary"
                  no-caret
                  offset="-125"
                >
                  <template #button-content>
                    <b-icon
                      class="icon kebab additional"
                      icon="three-dots-vertical"
                      font-scale="1"
                    />
                    <span class="sr-only">Additional Options</span>
                  </template>
                  <b-dropdown-item
                    :to="getMeetingUrl(data.item)"
                  >View Meeting</b-dropdown-item>
                </b-dropdown>
              </template>
              <template #cell()="data">
                <span v-if="!data.value">--</span>
                <span v-else>{{ data.value }}</span>
              </template>
            </b-table>
            <div class="btn-wrapper">
              <b-button
                v-if="meetings.length > meetingLength"
                @click="showMore('Meetings')"
                variant="tertiary"
                class="view"
              >Show More</b-button>
            </div>
          </div>
        </b-row>
      </b-tab>
    </b-tabs> -->
    <EditProjectMetricModal
      ref="add-action-item-modal"
      :projectId="projectId"
      title="New Action Item"
      :mode="'Add'"
      :possibleAssignees="projectUsers"
      :addTypes="['Risk', 'Issue']"
      :presetTags="presetTags"
      @submit="addProjectMetricSubmit"
    ></EditProjectMetricModal>
    <EditProjectMetricModal
      ref="add-efficiency-modal"
      :projectId="projectId"
      title="New Efficiency"
      :mode="'Add'"
      :possibleAssignees="projectUsers"
      :addTypes="['Efficiency']"
      :presetTags="presetTags"
      @submit="addProjectMetricSubmit"
      :dataTemplate="dataTemplateByType('Efficiency')"
    ></EditProjectMetricModal>
    <EditProjectMetricModal
      ref="add-innovation-modal"
      :projectId="projectId"
      title="New Innovation"
      :mode="'Add'"
      :possibleAssignees="projectUsers"
      :addTypes="['Innovation']"
      :presetTags="presetTags"
      @submit="addProjectMetricSubmit"
      :dataTemplate="dataTemplateByType('Innovation')"
    ></EditProjectMetricModal>
    <EditProjectMetricModal
      ref="add-sustainability-modal"
      :projectId="projectId"
      title="New Sustainability"
      :mode="'Add'"
      :possibleAssignees="projectUsers"
      :addTypes="['Sustainability']"
      :presetTags="presetTags"
      @submit="addProjectMetricSubmit"
      :dataTemplate="dataTemplateByType('Innovation')"
    ></EditProjectMetricModal>
    <EditProjectMetricModal
      ref="add-partnership-modal"
      :projectId="projectId"
      title="New Partnership"
      :mode="'Add'"
      :possibleAssignees="projectUsers"
      :addTypes="['Partnership']"
      :presetTags="presetTags"
      @submit="addProjectMetricSubmit"
      :dataTemplate="dataTemplateByType('Innovation')"
    ></EditProjectMetricModal>
    <EditNewsLinkModal ref="add-news-link-modal" :projectId="projectId" @submit="addNewsLinkSubmit"></EditNewsLinkModal>
    <b-modal
      title="Add documents"
      ref="add-document-modal"
      ok-title="Add"
      @ok.prevent="addDocumentSubmit"
    >
      <b-form>
        <b-form-group
          label="Name"
          label-for="doc-name"
          invalid-feedback="Please give the document a name"
        >
          <b-form-input
            id="doc-name"
            v-model.trim="form.name"
            maxlength="200"
            :state="errors.length == 0 ? null : form.name != ''"
            required
            autofocus
          ></b-form-input>
        </b-form-group>
        <b-form-group label="File" label-for="doc-upload">
          <b-form-file
            v-model="upload"
            :state="errors.length == 0 ? null : upload.length > 0"
            multiple
          >
            <template slot="file-name" slot-scope="{ names }">
              <b-badge variant="dark">{{ names[0] }}</b-badge>
              <b-badge
                v-if="names.length > 1"
                variant="dark"
                class="ml-1"
              >+ {{ names.length - 1 }} More files</b-badge>
            </template>
          </b-form-file>
        </b-form-group>
      </b-form>
    </b-modal>
    <b-modal title="Documents" ref="all-documents" ok-title="Close" ok-only>
      <DocumentEntries :documents="documents"></DocumentEntries>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
import ProjectMetricActionItems from "@/components/project/ProjectMetricActionItems.vue";
import EditProjectMetricModal from "@/components/modals/EditProjectMetricModal.vue";
import EditNewsLinkModal from "@/modal-components/EditNewsLinkModal.vue";
import ProjectMetricEntries from "@/components/list-entries/ProjectMetricEntries.vue";
import DocumentEntries from "@/list-entries-components/DocumentEntries.vue";
import NewsLinkEntries from "@/list-entries-components/NewsLinkEntries.vue";
export default {
  components: {
    ProjectMetricActionItems,
    EditProjectMetricModal,
    EditNewsLinkModal,
    ProjectMetricEntries,
    DocumentEntries,
    NewsLinkEntries,
  },
  props: {
    tabs: { type: Array, default: () => [] },
    projectMetrics: { type: Array, default: () => [] },
    projectId: { type: String, default: "" },
    projectUsers: { type: Array, default: () => [] },
    title: { type: String, default: "Action Items" },
    action: { type: String, default: "None" },
    viewByLink: { type: Boolean, default: true },
    allowAdd: { type: Boolean, default: false },
    addTypes: {
      type: Array,
      default: () => [
        "Risk",
        "Issue",
        "Efficiency",
        "Innovation",
        "Partnership",
        "Sustainability",
      ],
    },
    possibleAssignees: { type: Array, default: () => [] },
    showTypeBadge: { type: Boolean, default: false },
    showRemainingCount: { type: Boolean, default: false },
    showLimit: { type: Number, default: 5 },
    showDueDate: { type: Boolean, default: false },
    dataTemplate: Object,
    cardClass: { type: String, default: "mb-4" },
    presetTags: { type: Array, default: () => [] },
    documents: { type: Array, default: () => [] },
    news: { type: Array, default: () => [] },
  },
  data() {
    return {
      length: 6,
      innovationsLength: 6,
      efficienciesLength: 6,
      sustainabilityLength: 6,
      partnershipLength: 6,
      documentsLength: 6,
      meetingLength: 6,
      errors: [],
      upload: [],
      markLessonLearnedErrors: [],
      showMarkLessonLearnedForm: true,
      editingProjectMetric: null,
      viewingProjectMetric: null,
      closingProjectMetric: null,
      markLessonLearnedForm: {
        name: "",
        description: "",
      },
      sending: false,
      editProjectMetricKey: 0,
      currentTab: 0,
      form: {
        name: "",
      },
      innovationsFields: [
        { key: "name", label: "Item" },
        { key: "champion", label: "Champion(s)" },
        { key: "timeSaved", label: "Days Saved" },
        { key: "costSaved", label: "$ Saved" },
      ],
      efficienciesFields: [
        { key: "name", label: "Item" },
        { key: "champion", label: "Champion(s)" },
        { key: "timeSaved", label: "Days Saved" },
        { key: "costSaved", label: "$ Saved" },
      ],
      sustainabilitiesFields: [
        { key: "name", label: "Item" },
        { key: "champion", label: "Champion(s)" },
        { key: "timeSaved", label: "Days Saved" },
        { key: "costSaved", label: "$ Saved" },
      ],
      partnershipFields: [
        { key: "name", label: "Item" },
        { key: "champion", label: "Champion(s)" },
        { key: "timeSaved", label: "Days Saved" },
        { key: "costSaved", label: "$ Saved" },
      ],
      meetingFields: [
        { key: "name", label: "Meeting" },
        { key: "type", label: "Type" },
        {
          key: "status",
          label: "",
          tdClass: (value) =>
            `${value.toLowerCase().replace(/ /g, "-")} skinny-col`,
        },
        { key: "date", label: "Meeting Date", thClass: "skinny-col" },
        // { key: "start", label: "Date", thClass: "skinny-col" },

        { key: "addedMetricCount", label: "New Items", thClass: "skinny-col" },
        {
          key: "closedMetricCount",
          label: "Closed Items",
          thClass: "skinny-col",
        },
        { key: "attendeeCount", label: "Attendance", thClass: "skinny-col" },
        { key: "kebab", label: "", thClass: "skinny-col" },
      ],
      metricColumns: [
        { key: "name", label: "Item" },
        { key: "champion", label: "Champion(s)" },
        { key: "timeSaved", label: "Days Saved" },
        { key: "costSaved", label: "$ Saved" },
      ],
    };
  },
  methods: {
    showMore(item) {
      switch (item) {
        case "Innovations":
          this.innovationsLength += this.length;
          break;
        case "Efficiencies":
          this.efficienciesLength += this.length;
          break;
        case "Sustainability":
          this.sustainabilityLength += this.length;
          break;
        case "Partnership":
          this.partnershipLength += this.length;
          break;
        case "Documents":
          this.documentsLength += this.length;
          break;
      }
    },
    meetingName(name) {
      if (!name) return "No Meeting Name";
      if (name.includes("Instant Meeting"))
        return `${name.slice(0, 16)} ${this.$formatter.displayDate(
          name.slice(16)
        )}`;
      return name;
    },
    getMeetingUrl(meeting) {
      return meeting.type === 'Kick-Off Meeting' ?
        `/project/${meeting.projectId}/meeting-kickoff/${meeting.meetingId}` :
        `/project/${meeting.projectId}/meeting/${meeting.meetingId}`;
    },
    addDocument() {
      this.$refs["add-document-modal"].show();
    },
    addDocumentSubmit() {
      this.sending = true;
      if (!this.projectId || this.upload.length === 0 || !this.form.name) {
        return;
      }

      this.upload.forEach((file, i, files) => {
        let documentId = this.$helpers.generateUUID();

        //Post the documents
        let formData = new FormData();
        formData.append("file", file);
        formData.append("documentId", documentId);
        formData.append("documentType", "Project-Document");
        formData.append("name", this.form.name);
        formData.append("fileName", file.name);
        formData.append("contentType", file.type);
        formData.append("tableName", "Projects");
        formData.append("tableId", this.projectId);

        axios
          .post(
            `${this.$api_url}/documents/upload`,
            formData,
            this.getReqConfig({
              "Content-Type": "multipart/form-data",
            })
          )
          .then(() => {})
          .catch((err) => {
            this.errors.push(err);
            //Inform them a document didn't upload
          })
          .finally(() => {
            if (i === files.length - 1) {
              this.$emit("refresh", { name: "documents" });
              this.sending = false;
              this.reset();
              location.reload();
            }
          });
      });
    },
    reset() {
      this.upload = [];
      this.form = { name: "" };
      this.$refs["add-document-modal"].hide();
    },
    showModalVFor(name) {
      this.$refs[name][0].show();
    },
    hideModalVFor(name) {
      this.$refs[name][0].hide();
    },
    undoMarkClosed(id) {
      let projectMetric = this.projectMetrics.find(
        (a) => a.projectMetricId === id
      );

      let request = {
        ...projectMetric,
        dateClosed: null,
        resolution: "",
        resolutionLevel: "",
        dateResolved: null,
        resolvedBy: "",
        timeSaved: null,
        costSaved: null,
        mitigationMethod: "",
        mitigationMethodData: "",
        status: "Open",
      };

      this.sending = true;
      axios
        .post(
          `${this.$api_url}/project-metrics/update`,
          request,
          this.getReqConfig()
        )
        .then(() => {
          this.$emit("refresh");
        })
        .catch((err) => {
          this.$emit("error", err);
        })
        .finally(() => {
          this.sending = false;
        });
    },
    //Mark LessonLearned
    validateMarkLessonLearned() {
      const initErrors = this.markLessonLearnedErrors.length;
      this.markLessonLearnedForm = this.$helpers.trimObject(
        this.markLessonLearnedForm
      );

      if (this.markLessonLearnedForm.name.length === 0) {
        this.markLessonLearnedErrors.push({ message: "Please enter Name" });
      }

      return initErrors === this.markLessonLearnedErrors.length;
    },
    showMarkLessonLearnedModal(id) {
      let item = this.projectMetrics.find((pm) => pm.projectMetricId === id);
      this.markLessonLearnedForm.name = item.name;
      this.showModalVFor("mark-lesson-learned-modal-" + id);
    },
    onMarkLessonLearnedSubmit(id) {
      this.markLessonLearnedErrors = [];
      if (this.validateMarkLessonLearned()) {
        let item = this.projectMetrics.find((pm) => pm.projectMetricId === id);

        let lessonLearnedId = this.$helpers.generateUUID();
        let lessonLearned = {
          lessonLearnedId: lessonLearnedId,
          projectId: item.projectId,
          name: this.markLessonLearnedForm.name,
          description: this.markLessonLearnedForm.description,
          projectMetricId: id,
        };
        item.lessonLearnedId = lessonLearnedId;

        this.$parent.handleAddLessonLearned(lessonLearned);
        this.resetMarkLessonLearnedForm();
        this.hideModalVFor("mark-lesson-learned-modal-" + id);
      }
    },
    onMarkLessonLearnedCancel(id) {
      this.resetMarkLessonLearnedForm();
      this.hideModalVFor("mark-lesson-learned-modal-" + id);
    },
    resetMarkLessonLearnedForm() {
      this.markLessonLearnedForm = {
        name: "",
        description: "",
      };

      //Clear form
      this.showMarkLessonLearnedForm = false;
      this.$nextTick(() => {
        this.showMarkLessonLearnedForm = true;
      });
    },
    addActionItem() {
      this.$refs["add-action-item-modal"].show();
    },
    addInnovation() {
      this.$refs["add-innovation-modal"].show();
    },
    addEfficiency() {
      this.$refs["add-efficiency-modal"].show();
    },
    addSustainability() {
      this.$refs["add-sustainability-modal"].show();
    },
    addPartnership() {
      this.$refs["add-partnership-modal"].show();
    },
    addNewsLink() {
      this.$refs["add-news-link-modal"].show();
    },
    setCurrentTab(x) {
      this.currentTab = x;
    },
    addNew() {
      switch (this.currentTab) {
        case 0:
          this.addActionItem();
          break;
        case 1:
          this.addInnovation();
          break;
        case 2:
          this.addEfficiency();
          break;
        case 3:
          this.addSustainability();
          break;
        case 4:
          this.addDocument();
          break;
        case 5:
          this.addPartnership();
          break;
        case 6:
          this.addNewsLink();
          break;
        case 7:
          this.$emit("newMeeting");
          break;
      }
    },
    editProjectMetric(id) {
      this.editingProjectMetric = this.projectMetrics.find(
        (a) => a.projectMetricId === id
      );
      this.$nextTick(() => {
        this.$refs["edit-project-metric-modal"].show();
      });
    },
    viewProjectMetric(id) {
      this.viewingProjectMetric = this.projectMetrics.find(
        (a) => a.projectMetricId === id
      );

      this.$nextTick(() => {
        this.$refs["view-project-metric-modal"].show();
      });
    },
    closeProjectMetric(id) {
      this.closingProjectMetric = this.projectMetrics.find(
        (a) => a.projectMetricId === id
      );

      this.$nextTick(() => {
        this.$refs["close-project-metric-modal"].show();
      });
    },
    addProjectMetricSubmit() {
      this.$emit("refresh");
      this.$refs["add-action-item-modal"].cancel();
      this.$refs["add-innovation-modal"].cancel();
      this.$refs["add-efficiency-modal"].cancel();
      this.$refs["add-sustainability-modal"].cancel();
      this.$refs["add-partnership-modal"].cancel();
    },
    editProjectMetricSubmit() {
      this.$emit("refresh");
      this.$refs["edit-project-metric-modal"].cancel();
    },
    closeProjectMetricSubmit() {
      this.$emit("refresh");
      this.$refs["close-project-metric-modal"].cancel();
    },
    refreshSpecificProjectMetric(id) {
      this.$emit("refresh", {
        name: "project-metrics",
        id: id,
      });
    },
    dataTemplateByType(type) {
      if (type === "Innovation" || type === "Efficiency") {
        return {
          overrides: [
            {
              actions: ["Add"],
              key: "status",
              value: "Closed",
            },
          ],
        };
      }
      return null;
    },
    addNewsLinkSubmit() {
      this.$emit("refresh", { name: "news-links" });
      this.$refs["add-news-link-modal"].cancel();
    },
    compareMeetDate: (a, b) => {
      if (a.date > b.date || b.date == null) {
        return -1;
      } else if (a.date < b.date) return 1;
      return 0;
    },
  },
  computed: {
    actionItems() {
      return this.projectMetrics.filter(
        (p) => p.type === "Risk" || p.type === "Issue"
      );
    },
    innovations() {
      return this.projectMetrics.filter((p) => p.type.includes('Innovation'));
    },
    visibleInnovations() {
      return this.innovations.slice(0, this.innovationsLength);
    },
    efficiencies() {
      return this.projectMetrics.filter((p) => p.type.includes('Efficiency'));
    },
    visibleEfficiencies() {
      return this.efficiencies.slice(0, this.length);
    },
    sustainabilities() {
      return this.projectMetrics.filter((p) => p.type.includes('Sustainability'));
    },
    visibleSustainabilities() {
      return this.sustainabilities.slice(0, this.length);
    },
    partnerships() {
      return this.projectMetrics.filter((p) => p.type.includes('Partnership'));
    },
    visiblePartnerships() {
      return this.partnerships.slice(0, this.length);
    },
    titleHeader() {
      var header = this.title;

      if (this.showRemainingCount) {
        let count = this.projectMetrics.length;
        header += `${count > 0 ? ` (${count} left)` : ""}`;
      }
      return header;
    },
    nextTwoYears() {
      var futureDates = [];

      let today = new Date();
      futureDates[0] = today.toLocaleString("default", {
        month: "long",
        year: "numeric",
      });
      for (var i = 1; i < 24; i++) {
        let date = new Date(new Date(today).setMonth(today.getMonth() + i));
        futureDates[i] = date.toLocaleString("default", {
          month: "long",
          year: "numeric",
        });
      }

      return futureDates;
    },
    visibleDocuments() {
      return this.documents.slice(0, this.length);
    },
    addNewText() {
      switch (this.currentTab) {
        case 0:
          return "Add Action Item";
        case 1:
          return "Add Innovation";
        case 2:
          return "Add Efficiency";
        case 3:
          return "Add Sustainability";
        case 4:
          return "Add Document";
        case 5:
          return "Add Partnership";
        case 6:
          return "Add News Link";
        case 7:
          return "Add Meeting";
      }
    },
  },
};
</script>